import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=36510bfa&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=36510bfa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36510bfa",
  null
  
)

export default component.exports